// extracted by mini-css-extract-plugin
export default {"root":"dBrVkJ52aZww9K0vPEcA","question":"aeTud8gkZPOOk1PDkh7k","ordinal":"zM2fQbqUmOUnUIdxfZLI","answer":"UF4Y4YlWJO7M5bTs5l5K","condition":"Kh7fMFW60Ce51EWnfGUM"};